import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App.jsx';
import './styles/tokens.css';
import './styles/app.css';
import './components/primitives.css';
import './components/charts/charts.css';
import './components/inspectors/inspectors.css';

// PRIME-ARCH-001 seam 1 (router half): derive the router basename from the
// single Vite base knob. import.meta.env.BASE_URL is '/' by default, so the
// stripped value falls back to '/' — react-router's own default — keeping the
// standalone build's routing behavior byte-for-byte unchanged. When PRIME is
// built under a non-root base (VITE_APP_BASE_PATH=/prime/), BASE_URL becomes
// '/prime/' and every route resolves under that prefix with no per-route edits.
const routerBasename = import.meta.env.BASE_URL.replace(/\/+$/, '') || '/';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter
      basename={routerBasename}
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
